let localinnerAppId = ''
export const setLocalinnerAppId = (appId) => {
  localinnerAppId = appId
}
export const localSave = (key, value) => {
  localStorage.setItem(key, value)
}

export const localRead = (key) => {
  return localStorage.getItem(key) || ''
}

export const formatFileSize = (limit) => {
  var size = ''
  if (limit < 0.1 * 1024) { //如果小于0.1KB转化成B
    size = limit.toFixed(2) + 'B'
  } else if (limit < 0.1 * 1024 * 1024) { //如果小于0.1MB转化成KB
    size = (limit / 1024).toFixed(2) + 'KB'
  } else if (limit < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
    size = (limit / (1024 * 1024)).toFixed(2) + 'MB'
  } else { //其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }

  var sizestr = size + ''
  var len = sizestr.indexOf('\.')
  var dec = sizestr.substr(len + 1, 2)
  if (dec == '00') { //当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}
// 根据文件后缀名获取文件类型
export const getFileType = (fileName) => {
  // 后缀获取
  var suffix = ''
  // 获取类型结果
  var result = ''
  try {
    var flieArr = fileName.toLowerCase().split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = false
    return result
  }
  // 图片格式
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
  // 进行图片匹配
  result = imglist.some((item) => {
    return item == suffix
  })
  if (result) {
    result = 'image'
    return result
  }
  // 匹配 视频
  var videolist = ['mp4', 'm2v', 'mkv', 'avi', 'rmvb']
  result = videolist.some((item) => {
    return item == suffix
  })
  if (result) {
    result = 'video'
    return result
  }
  // 匹配 音频
  var radiolist = ['mp3', 'wav', 'wmv']
  result = radiolist.some((item) => {
    return item == suffix
  })
  if (result) {
    result = 'audio'
    return result
  }
  // 匹配txt
  var txtlist = ['txt']
  result = txtlist.some((item) => {
    return item == suffix
  })
  if (result) {
    result = 'txt'
    return result
  }
  // 匹配 excel
  var excelist = ['xls', 'xlsx']
  result = excelist.some((item) => {
    return item == suffix
  })
  if (result) {
    result = 'excel'
    return result
  }
  // 匹配 word
  var wordlist = ['doc', 'docx']
  result = wordlist.some((item) => {
    return item == suffix
  })
  if (result) {
    result = 'word'
    return result
  }
  // 匹配 pdf
  var pdflist = ['pdf']
  result = pdflist.some((item) => {
    return item == suffix
  })
  if (result) {
    result = 'pdf'
    return result
  }
  // 匹配 ppt
  var pptlist = ['ppt', 'pptx']
  result = pptlist.some((item) => {
    return item == suffix
  })
  if (result) {
    result = 'ppt'
    return result
  }
  // 匹配压缩包
  var packagelist = ['rar', 'zip', 'arj', 'gz', 'z']
  result = packagelist.some((item) => {
    return item == suffix
  })
  if (result) {
    result = 'package'
    return result
  }
  // 其他 文件类型
  result = 'other'
  return result
}

// 将日期转化为 今天，昨天等
export const formatDate = (date) => {
  let year = parseInt(date.split('-')[0])
  let mouth = parseInt(date.split('-')[1])
  let day = parseInt(date.split('-')[2])
  let curYear = new Date().getFullYear()
  let curMouth = new Date().getMonth() + 1
  let curDay = new Date().getDate()
  let result = ''
  if (year === curYear) {
    if (mouth === curMouth) {
      let offset = Math.abs(curDay - day)
      if (offset === 0) {
        result = '今天'
      } else if (offset === 1) {
        result = '昨天'
      } else {
        result = mouth + '月' + day + '日'
      }
    } else {
      result = mouth + '月' + day + '日'
    }
  } else {
    result = year + '年' + mouth + '月' + day + '日'
  }
  return result
}

/**
 * 文件大小转换
 * @param fileByte
 * @returns {string}
 */
export const getFileSize = (fileByte) => {
  var fileSizeByte = fileByte
  var fileSizeMsg = ''
  if (fileSizeByte == null || fileSizeByte == 0) {
    fileSizeMsg = ''
  } else if (fileSizeByte < 1048576) {
    fileSizeMsg = (fileSizeByte / 1024).toFixed(2) + 'KB'
  } else if (fileSizeByte == 1048576) {
    fileSizeMsg = '1MB'
  } else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) {
    fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(2) + 'MB'
  } else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) {
    fileSizeMsg = '1GB'
  } else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) {
    fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  } else {
    fileSizeMsg = '文件超过1TB'
  }
  return fileSizeMsg
}

export const formatNowDateDifference = (dateStr, isShowMonth) => {
  var date = new Date(dateStr.replace(/-/g, '/'))
  var nowDate = new Date()
  const nowYear = nowDate.getFullYear()
  const nowMonth = nowDate.getMonth() + 1
  const nowDay = nowDate.getDate()
  const nowHour = nowDate.getHours()
  const nowMinute = nowDate.getMinutes()
  const nowSecond = nowDate.getSeconds()
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  var addStr = ''
  if (nowYear === year && month === nowMonth && day === nowDay) {
    if (nowHour === hour) {
      if (nowMinute === minute) {
        addStr = (nowSecond - second) + '秒前'
      } else {
        addStr = (nowMinute - minute) + '分钟前'
      }
    } else {
      addStr = (nowHour - hour) + '小时前'
    }

  }
  if (nowYear === year && month === nowMonth && day === (nowDay - 1)) {
    addStr = '昨天'
  }
  if (nowYear === year && month === nowMonth && day === (nowDay - 2)) {
    addStr = '前天'
  }
  if (isShowMonth) {
    if (nowYear === year && addStr.length <= 0) {
      addStr = [month, day].map(formatNumbers).join('.')
    }
    if (nowYear !== year && addStr.length <= 0) {
      addStr = [year, month, day].map(formatNumbers).join('.')
    }
  }

  return addStr
}

const formatNumbers = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

/**
 * 数字保留小数处理
 * @param {Number} num  我们希望传一个数字参数
 * @param {Number} tofixed 这里是一个Number型参数，如果不传或者传null，我们不做保留小数处理
 */
export const formatNumber = (num, tofixed) => {
  if (num === null || num === undefined) {
    return num
  }
  let str = parseFloat(num)
  if (tofixed !== undefined && tofixed !== null) {
    str = Math.round(str * Math.pow(10, tofixed)) / Math.pow(10, tofixed)
    if (tofixed > 0) {
      let s = str.toString()
      let rs = s.indexOf('.')
      if (rs <= 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + tofixed) {
        s += '0'
      }
      str = s
    }
  }
  return str
}

/**
 * 千分符转换
 * @param {Number} num  我们希望传一个数字参数
 * @param {Number} tofixed 这里是一个Number型参数，如果不传或者传null，我们不做保留小数处理
 * @param {Boolean} complete 默认false，表示只对整数部分做千分符处理，true表示小数部分也做千分处理
 */
export function thousands (num, tofixed, complete = false) {
  if (num === null || num === undefined) {
    return num
  }
  let str = parseFloat(num)
  if (tofixed !== undefined && tofixed !== null) {
    str = Math.round(str * Math.pow(10, tofixed)) / Math.pow(10, tofixed)
    if (tofixed > 0) {
      let s = str.toString()
      let rs = s.indexOf('.')
      if (rs <= 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + tofixed) {
        s += '0'
      }
      str = s
    }
  }
  str = str + ''
  return complete
    ? str.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    : /\./.test(str)
      ? str.replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      : str.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
}

/** 数字金额大写转换(可以处理整数,小数,负数) */
export function smalltoBIG (n, units = 'CNY') {
  let unitList = {
    USD: '美元',
    $: '美元',
    EUR: '欧元',
    CNY: '元',
    S$: '新元',
    '₩': '韩元',
    'J¥': '日元',
    HKD: '港元',
    HK$: '港元',
    '€': '欧元'
  }

  let fraction = ['角', '分']
  let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  let unit = [
    [unitList[units], '万', '亿'],
    ['', '拾', '佰', '仟']
  ]
  let head = n < 0 ? '欠' : ''
  n = Math.abs(n)

  let s = ''

  for (let i = 0; i < fraction.length; i++) {
    s += (
      digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]
    ).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)

  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = ''
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(n / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, unitList[units])
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零' + unitList[units] + '整')
  )
}
